import { GridCellProps } from '@progress/kendo-react-grid';

type Props = {
  className?: string;
  e: GridCellProps;
  onClick?: (e) => void;
};

const SIFamountPaidCell = ({ className, e, onClick }: Props) => {
  const data = e?.dataItem;
  return (
    <td className={className ?? ''}>
      <div>{data?.sifAmountPaid}</div>
    </td>
  );
};

export default SIFamountPaidCell;
